import * as React from 'react';

import { Button } from 'semantic-ui-react';

import { localeData } from '../../../locales/data';
import FlashMessages from '../../FlashMessages/FlashMessages';

import './SourceCodeEditor.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface SourceCodeEditorBottomProps {
  handlerThemeLight: () => void;
  handlerThemeDark: () => void;
  handleCleanTabCodeError: () => void;
  handleCloneAlpha: () => void;
  isSimulating: boolean;
  isMobile: boolean;
  activeTab: any;
  shouldDisableClone: boolean;
}

const SourceCodeEditorBottom = ({
  handlerThemeLight,
  handlerThemeDark,
  handleCleanTabCodeError,
  handleCloneAlpha,
  isMobile,
  activeTab,
  shouldDisableClone,
}: SourceCodeEditorBottomProps) => (
  <React.Fragment>
    {!isMobile && (
      <div className="editor-code__bottom-actions">
        <div className="editor-code__buttons">
          <Button disabled={Boolean(shouldDisableClone)} className="editor-code__clone-button" onClick={handleCloneAlpha}>
            <span className="editor-tabs__new-tab-icon">+</span>
            <span className="editor-tabs__new-tab-text">
              <FormattedMessageHelper
                tagName="span"
                id="codeEditor.cloneThisAlpha"
                defaultMessage={localeData.en['codeEditor.cloneThisAlpha']}
              />
            </span>
          </Button>

          <button className="editor-code__buttons--light" onClick={handlerThemeLight} />
          <button className="editor-code__buttons--dark" onClick={handlerThemeDark} />
        </div>

        <div className="editor-code__flash-message">
          <FlashMessages location="editor-code" handleCleanTabCodeError={handleCleanTabCodeError} />
        </div>
      </div>
    )}
    {isMobile && activeTab.get('childTabs') && (
      <div className="editor-multi-simulation__modal--disabled">
        <span className="editor-multi-simulation__modal--icon editor-tabs__tab-dot--fail" />
        <div>
          <FormattedMessageHelper
            tagName="span"
            id="codeEditor.multi.simulation.disabled.1"
            defaultMessage={localeData.en['codeEditor.multi.simulation.disabled.1']}
          />
          <br />
          <FormattedMessageHelper
            tagName="span"
            id="codeEditor.multi.simulation.disabled.2"
            defaultMessage={localeData.en['codeEditor.multi.simulation.disabled.2']}
          />
        </div>
      </div>
    )}
  </React.Fragment>
);

export default SourceCodeEditorBottom;
